module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_vm._v("Knitting know-how")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fair Isle")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lace Border")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anchor")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bird")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Embroidered Flowers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frog")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fair Isle Border")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heart")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ladybird")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dashes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mouse")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Star")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Owl")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Twists")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snowflake")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spotted Pony")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stripes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tweed")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-ch"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tiger Stripes")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f004-01.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0